export default "__VITE_ASSET__CkpAtUnR__"